<template>
  <div class="name">
    <div class="gignac-andre-pierre valign-text-middle avenirnextltpro-bold-white-16px">{{ playerName }}</div>
  </div>
</template>

<script>
import playerHeaderMixin from '@/utils/mixins/player-header';
export default {
  name: 'Name',
  props: {
    player: {
      type: Object,
      required: true,
    },
    value: {
      type: Number,
      default: -1,
    },
  },
  mixins: [playerHeaderMixin],
};
</script>

<style>
.name,
.name-1,
.name-2 {
  align-items: flex-start;
  display: flex;
  gap: 10px;
  padding: 3px 0px;
  position: relative;
  width: fit-content;
}

.gignac-andre-pierre,
.gignac-andre-pierre-1,
.gignac-andre-pierre-2 {
  letter-spacing: 0;
  line-height: 13px;
  margin-top: -1px;
  position: relative;
  text-shadow: 0px 1.93px 1.93px #162b3436;
  white-space: nowrap;
  width: fit-content;
}
</style>
